import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  checkboxGridItem: {
    display: 'flex',
    alignItems: 'flex-start'
  },
  checkboxContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    textAlign: 'start'
  }
}));

export default useStyles;
